import type {UseMutationResult} from '@tanstack/react-query';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {CapacityOverride} from '@/types/CapacityOverride';
import {apiUrl} from '@/utils/api';

export const useUpdateCapacityOverride = () : UseMutationResult<
    void,
    unknown,
    CapacityOverride
> => {
    const fetch = useApiFetch();
    const queryClient = useQueryClient();

    return useMutation(async (values : CapacityOverride) => {
        try {
            await fetch(apiUrl('/v1/capacity/capacity/update-override').toString(), {
                method: 'PUT',
                body: JSON.stringify(values),
            });
        } catch (e : unknown) {
            throw new Error('Unable to save capacity override.');
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['capacityCombined']);
        },
    });
};
